export function formatSurveyInstanceCount(value) {
  if (!Array.isArray(value) || value.length === 0) {
    return "";
  }

  let count220 = 0;
  let countUnder220 = 0;

  value.forEach(item => {
    const count = Number(item?.SurveyInstanceCount) || 0;
    const statusId = Number(item?.SurveyInstanceStatusId);

    if (statusId === 220) {
      count220 += count;
    } else if (statusId < 220) {
      countUnder220 += count;
    }
  });

  const plannedSurveyInstances =
    value[0]?.PlannedSurveyInstanceNumber ?? "";

  return `${countUnder220}/${count220} (${plannedSurveyInstances})`;
}

export function createExcelExportParams(formatters = {}) {
  return {
    processCellCallback(params) {
      const columnId = params.column.getColId();
      const formatter = formatters[columnId];

      if (formatter) {
        return formatter(params.value, params);
      }

      if (params.value === null || params.value === undefined) {
        return "";
      }

      return params.value;
    }
  };
}